import { CityDataType } from "@website/accommodation-ui/hotel-search";
import { isChannel } from "@website/utils/channel/helpers";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { CMSSeoContentData } from "@website/website-ui/services/seo-contents/cms-types";
import toString from "lodash-es/toString";
import Head from "next/head";

const staticCitiesMetaTags = {
  تهران: [
    {
      name: "geo.region",
      content: "IR-TH"
    },
    {
      name: "geo.placename",
      content: "Tehran"
    },
    {
      name: "geo.position",
      content: "35.6892;51.3890"
    },
    {
      name: "ICBM",
      content: "35.6892,51.3890"
    }
  ],
  مشهد: [
    {
      name: "geo.region",
      content: "IR-KH"
    },
    {
      name: "geo.placename",
      content: "Mashhad"
    },
    {
      name: "geo.position",
      content: "36.2605;59.6168"
    },
    {
      name: "ICBM",
      content: "36.2605,59.6168"
    }
  ],
  تبریز: [
    {
      name: "geo.region",
      content: "IR-EB"
    },
    {
      name: "geo.placename",
      content: "Tabriz"
    },
    {
      name: "geo.position",
      content: "38.0962;46.2738"
    },
    {
      name: "ICBM",
      content: "38.0962,46.2738"
    }
  ],
  اصفهان: [
    {
      name: "geo.region",
      content: "IR-ES"
    },
    {
      name: "geo.placename",
      content: "Isfahan"
    },
    {
      name: "geo.position",
      content: "32.6539;51.6660"
    },
    {
      name: "ICBM",
      content: "32.6539,51.6660"
    }
  ],
  شیراز: [
    {
      name: "geo.region",
      content: "IR-FR"
    },
    {
      name: "geo.placename",
      content: "Shiraz"
    },
    {
      name: "geo.position",
      content: "29.5918;52.5837"
    },
    {
      name: "ICBM",
      content: "29.5918,52.5837"
    }
  ],
  کیش: [
    {
      name: "geo.region",
      content: "IR-HO"
    },
    {
      name: "geo.placename",
      content: "Kish"
    },
    {
      name: "geo.position",
      content: "26.5320;53.9800"
    },
    {
      name: "ICBM",
      content: "26.5320,53.9800"
    }
  ],
  قشم: [
    {
      name: "geo.region",
      content: "IR-HO"
    },
    {
      name: "geo.placename",
      content: "Qeshm"
    },
    {
      name: "geo.position",
      content: "26.9584;56.2719"
    },
    {
      name: "ICBM",
      content: "29.5918,52.5837"
    }
  ],
  یزد: [
    {
      name: "geo.region",
      content: "IR-YZ"
    },
    {
      name: "geo.placename",
      content: "Yazd"
    },
    {
      name: "geo.position",
      content: "31.8974;54.3569"
    },
    {
      name: "ICBM",
      content: "31.8974,54.3569"
    }
  ]
};

type MetaType = {
  seoData: CMSSeoContentData;
  queryCityTitle: string | Array<string>;
  cityData: CityDataType;
};

export const Meta = ({ seoData, cityData, queryCityTitle }: MetaType) => {
  const { title: cityTitle } = cityData || {};

  const pageTitle =
    seoData?.title ??
    `رزرو هتل ${cityTitle} قسطی - هتل های ${cityTitle} با پشتیبانی 24 ساعته`;

  const pageDescription =
    seoData?.description ??
    `رزرو هتل های ${cityTitle} با کمترین قیمت. لیست قیمت بهترین هتل و هتل آپارتمان های ${cityTitle} با بیشترین تخفیف، رزرو قسطی هتل در ${cityTitle} با پشتیبانی 24 ساعته و کنسلی لحظه ای`;

  return (
    <Head>
      {staticCitiesMetaTags?.[toString(queryCityTitle)]?.map(
        ({ name, content }) => (
          <meta content={content} key={content} name={name} />
        )
      )}
      {isChannel(["snapp-ir"]) ? (
        <title>
          {`رزرو هتل ${cityData?.title} با بیشترین تخفیف و پرداخت قسطی - اسنپ`}
        </title>
      ) : (
        <title>{replaceSnappTripBasedOnChannel(pageTitle)}</title>
      )}
      <meta name="description" content={pageDescription} />
    </Head>
  );
};
